import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Form, Row, Col, Select, Input} from 'antd'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import FormModal from './FormModal'
import {PlusOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
const storage = window.localStorage

@inject('marketingSmsManagementStore', 'accountStore')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: this.props?.location?.state?.addModalVisible || false,
  }
  formRef = React.createRef()
  handleSearch = () => {
    const {marketingSmsManagementStore, accountStore, type} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        'smsType': type,
        'marketGroupId': fieldsValue.marketGroupId || '',
        'configName': fieldsValue.configName || '',
        'signId': fieldsValue.signId || '',
        'smsContent': fieldsValue.smsContent || '',
        'expoResume': fieldsValue.expoResume || '',
        'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
        'page': 1,
        'size': PAGE_SIZE_DEFAULT
      }
      marketingSmsManagementStore.onSearchAction(params)
    }).catch(err => {
    })
  }
  handleCreate = () => {
    const {marketingSmsManagementStore} = this.props
    marketingSmsManagementStore.onGenerateIDAction().then(response=> {
      if (response?.data?.code === 0) {
        this.setState({
          addModalVisible: true
        })
      }
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }
  handleSync = () => {
    const {marketingSmsManagementStore} = this.props
    marketingSmsManagementStore.onSyncAction()
  }
  onChange=(val)=> {
    const {marketingSmsManagementStore, accountStore, type} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    marketingSmsManagementStore.onGetSign({
      marketGroupId: val,
      smsType: type,
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
    })
    this.formRef.current.setFieldsValue({
      signId: undefined
    })
  }
  render() {
    const {marketingSmsManagementStore, type, location, t} = this.props
    const {groupList, signList, expoList} = marketingSmsManagementStore
    return (
      <>
        <Form ref={this.formRef} size="middle" className="searchForm">
          <Row gutter={[10, 10]}>
            <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={6} span={6}>
              <Form.Item name="marketGroupId" label={t(`marketingManagement.marketingGroup`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                } onChange={this.onChange}>
                  {groupList?.map(item => (<Select.Option key={item.id} value={item.id}>{item.groupName}</Select.Option>))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={6} span={6}>
              <Form.Item name="configName" label={t(`marketingManagement.taskName`)}
                rules={[{
                  message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.taskName`)} ${t(`general.withoutSpecialChats`)}`,
                  pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                }]}
              >
                <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>
            <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={6} span={6}>
              <Form.Item name="signId" label={t(`marketingManagement.signature`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }>
                  {signList?.map(item => (<Select.Option key={item.id} value={item.id}>{item.sign}</Select.Option>))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={6} span={6}>
              <Form.Item name="smsContent" label={t(`marketingManagement.smsContent`)}
                rules={[{
                  message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.smsContent`)} ${t(`general.withoutSpecialChats`)}`,
                  pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                }]}
              >
                <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>
            <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={6} span={6}>
              <Form.Item name="expoResume" label={t(`marketingManagement.exhibitionSession`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }>
                  {expoList?.map(item => (<Select.Option key={item?.expoResume} value={item?.expoResume}>{item?.expoCityName ? `${item?.expoResume}-${item?.expoCityName}` : `${item?.expoResume}`}</Select.Option>))}
                </Select>
              </Form.Item>
            </Col>
            <Col flex='auto' style={{textAlign: 'right', marginBottom: 10}}>
              <Button onClick={this.handleSearch} type='danger'>{t(`general.search`)}</Button>
              <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
              {/* <Button onClick={this.handleSync} type="primary" icon={<SyncOutlined />}>{t(`general.sync`)}</Button> */}
            </Col>
          </Row>
        </Form>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          location={location}
          type={type}
          onSearch={this.handleSearch}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchForm)
